
export const STATUS_OFFLINE = 'offline';
export const STATUS_ONLINE = 'online';
export const STATUS_AWAY = 'away';
export const STATUS_PRIVATE = 'private';
//export const STATUS_GROUP = 'group';
export const STATUS_PLEDGE_INIT = 'pledge_init';
export const STATUS_PLEDGE_SHOW = 'pledge_show';
export const STATUS_HIDDEN_CAM = 'hidden_cam';

export const CHAT_TYPE_OFFLINE = 'offline';
export const CHAT_TYPE_PUBLIC = 'public';
export const CHAT_TYPE_PRIVATE = 'private';
export const CHAT_TYPE_SPY = 'spy';
//export const CHAT_TYPE_GROUP = 'group';
export const CHAT_TYPE_PLEDGE = 'pledge';
